import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'
import { compose } from 'redux'

import { fetchMarketYoyGrowthExpectations } from '../../api'
import { selectIsMarketYoyGrowthExpectationsFetching } from '../selectors'

export const requestMarketYoyGrowthExpectationsData = createAsyncThunk(
  'marketYoyGrowthExpectation/requestMarketYoyGrowthExpectationsData',
  ({ fYear }: { fYear: number }) => fetchMarketYoyGrowthExpectations({ fYear }),
  {
    condition: (_, { getState }) => {
      const isMarketYoyGrowthExpectationsFetching = compose(
        selectIsMarketYoyGrowthExpectationsFetching,
        getState
      )()

      return !isMarketYoyGrowthExpectationsFetching
    },
  }
)
